import { all, call, put, takeEvery } from 'redux-saga/effects';
import { Api } from '$api';

import { mainActions } from '$store/main';
import { toastActions } from '$store/toast';
import { paymentMethodsActions } from '$store/paymentMethods';
import { balanceActions } from '$store/balance';
import { RemoveCardAction, SetActiveCardAction } from '$store/paymentMethods/interface';

function* setActiveCardWorker(cards) {
  for (let card of cards) {
    if (card?.active) {
      yield put(mainActions.setCard(card));
      break;
    }
  }
}

function* loadCardsWorker() {
  try {
    const data = yield call(Api.get, '/pay/cards');

    yield put(paymentMethodsActions.setCards(data.cards));
    yield put(balanceActions.setTopUpActive({ topUpActive: false }));
    yield setActiveCardWorker(data.cards);

    if (!data.cards.length) {
      yield put(mainActions.setCard(null));
    }
  } catch (e) {
    yield put(toastActions.setToastFail(e));
  }
}

function* setActiveCardsWorker({ payload: { id } }: SetActiveCardAction) {
  try {
    const data = yield call(Api.post, `/pay/cards/${id}/active`, {
      active: true,
    });

    if (data?.status === 'ok') {
      yield put(paymentMethodsActions.setCards(data.cards));
      yield setActiveCardWorker(data.cards);
    }
  } catch (e) {
    yield put(toastActions.setToastFail(e));
  }
}

function* removeCardWorker({ payload: { id } }: RemoveCardAction) {
  try {
    const data = yield call(Api.post, `/pay/cards/${id}/delete`);

    if (data?.status === 'ok') {
      yield put(paymentMethodsActions.setCards(data.cards));
      yield setActiveCardWorker(data.cards);

      if (!data.cards.length) {
        yield put(mainActions.setCard(null));
      }
    }
  } catch (e) {
    yield put(toastActions.setToastFail(e));
  }
}

export function* paymentMethodsSaga() {
  yield all([
    takeEvery(paymentMethodsActions.loadCards, loadCardsWorker),
    takeEvery(paymentMethodsActions.setActiveCards, setActiveCardsWorker),
    takeEvery(paymentMethodsActions.removeCard, removeCardWorker),
  ]);
}
